<template>
  <div>
  <div class="coins_wrappper">
      <p class="coins_text">当前可用（券币）</p>
      <p class="coins_num">30922</p>
  </div>
  <div class="mark">
    累计使用129000券币
  </div>
  <div class='list_wrapper'>
     <div class='buy_list'>
       <div class='circle circle1'></div>
       <div class='circle circle2'></div>
       <div class='circle circle3'></div>
       <div class='circle circle4'></div>
       <div class='buy_list_wrapper'>
         <div class='buy_list_pic_wrapper'>
             <img src='https://souquan.wang/api/images/sg_1524398251312_0.jpg' class='buy_list_pic' />
         </div>
         <div class='buy_list_content_wrapper'>
           <div class='buy_list_title'>金丝菊1罐＋黄菊2罐<text class='buy_num'>（1份）</text></div>
           <div class='buy_list_user_name'><img src='https://souquan.wang/api/images/sg_1524398251312_0.jpg' class='buy_list_avater' /><span>@＊＊美</span></div>
         </div>
         <div class='buy_list_time_wrapper'>
             <div class='buy_list_time'>5天前</div>
             <img src='../../images/dhcg.jpg' class='dhcg' />
         </div>
       </div>
     </div>
     <div class='buy_list'>
       <div class='circle circle1'></div>
       <div class='circle circle2'></div>
       <div class='circle circle3'></div>
       <div class='circle circle4'></div>
       <div class='buy_list_wrapper'>
         <div class='buy_list_pic_wrapper'>
             <img src='https://souquan.wang/api/images/sg_1524398251312_0.jpg' class='buy_list_pic' />
         </div>
         <div class='buy_list_content_wrapper'>
           <div class='buy_list_title'>金丝菊1罐＋黄菊2罐<text class='buy_num'>（1份）</text></div>
           <div class='buy_list_user_name'><img src='https://souquan.wang/api/images/sg_1524398251312_0.jpg' class='buy_list_avater' /><span>@＊＊美</span></div>
         </div>
         <div class='buy_list_time_wrapper'>
             <div class='buy_list_time'>5天前</div>
             <img src='../../images/dhcg.jpg' class='dhcg' />
         </div>
       </div>
     </div>
     <div class='buy_list'>
       <div class='circle circle1'></div>
       <div class='circle circle2'></div>
       <div class='circle circle3'></div>
       <div class='circle circle4'></div>
       <div class='buy_list_wrapper'>
         <div class='buy_list_pic_wrapper'>
             <img src='https://souquan.wang/api/images/sg_1524398251312_0.jpg' class='buy_list_pic' />
         </div>
         <div class='buy_list_content_wrapper'>
           <div class='buy_list_title'>金丝菊1罐＋黄菊2罐<text class='buy_num'>（1份）</text></div>
           <div class='buy_list_user_name'><img src='https://souquan.wang/api/images/sg_1524398251312_0.jpg' class='buy_list_avater' /><span>@＊＊美</span></div>
         </div>
         <div class='buy_list_time_wrapper'>
             <div class='buy_list_time'>5天前</div>
             <img src='../../images/dhcg.jpg' class='dhcg' />
         </div>
       </div>
     </div>
    </div>
  </div>
</template>
<script type = "text/ecamscript-6">
/* eslint-disable */
  export default {
    name:"myBuyScoreMallGoodRecord",
  }
</script>
<style lang="stylus">
  .coins_wrappper
    padding:50px 40px 30px 40px
    background:linear-gradient(to right,#ff0026,#ff6f25)
    .coins_text
      font-size:28px
      color:#fff
    .coins_num
      font-size:100px
      color:#fff
      margin-top:15px
  .mark
    font-size:24px
    color:#999
    margin-top:20px
    padding-left:40px
    box-sizing:border-box
    line-height:40px
  .list_wrapper
    width: 100%;
    box-sizing: border-box;
    padding: 10px 20px
    overflow:hidden
    .buy_list
      width: 100%
      background: #fff
      padding: 18px 20px
      background: #fff
      position: relative
      box-sizing: border-box
      border-bottom: 1px dashed #d5d5d5
      /*px*/
      .circle
        width: 32px
        height: 32px
        background: #f2f2f2
        position: absolute
        border-radius: 16px
      .circle1
        left: -16px
        top: -16px
      .circle2
        right: -16px
        top: -16px
      .circle3
        left: -16px
        bottom: -16px
      .circle4
        right: -16px
        bottom: -16px
      .buy_list_wrapper
        display: flex
        .buy_list_pic_wrapper
           flex: 0 0 160px
           .buy_list_pic
             width: 160px
             height: 160px
        .buy_list_content_wrapper
          flex: 1
          padding-left: 20px
          .buy_list_title
            font-size: 28px
            color: #333
            line-height: 32px
            margin-top: 20px
          .buy_list_user_name
            line-height: 50px
            font-size: 28px
            color: #696969
            margin-top: 30px
            .buy_list_avater
              width: 50px
              height: 50px
              border-radius: 25px
              vertical-align: middle
              margin-right: 20px
        .buy_list_time_wrapper
          flex: 0 0 160px
          text-align: right
          position: relative
          .buy_list_time
            font-size: 22px
            color: #999
          .dhcg
            position: absolute
            right: -18px
            top: 60%
            width: 118px
            height: 101px
            transform:translateY(-50%)
</style>



// WEBPACK FOOTER //
// src/components/userCenter/myBuyScoreMallGoodRecord.vue